<template>
    <div class="container-fluid w-100 h-100 pb-3" style="overflow-x: hidden">
        <navbar :title="$t('menu.certificate_report')" class="mb-1"/>
        <div class="mb-2">
            <div class="form-check form-switch ms-1">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="activeUsers"
                    v-model="activeUsers"
                    @change="fetchUserCertificates"
                />
                <label class="form-check-label" for="activeUsers">
                    {{ $t('contractor_reports.only_active_users') }}
                </label>
            </div>
        </div>
        <certificate-table
            v-if="!loading"
            class="my--2"
            :users="results"
            :certificates="certificates"
        />
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import CertificateTable from "./CertificateTable";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'CertificateReport',
    components: {Navbar, CertificateTable},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            results: [],
            certificates: [],
            fields: [],
            tableData: [],
            lastModified: null,
            loading: true,
            activeUsers: true
        }
    },
    mounted() {
        this.fetchCertificates()
    },
    methods: {
        fetchCertificates: function () {
            this.loading = true
            this.certificates = []
            this.restFetch(this.certificateTypeUrl, this.handleResponse, this.fail)
        },
        handleResponse: function (response) {
            this.loading = false
            if (response.data) {
                this.certificates = response.data
                // Fetch user certificate data
                this.fetchUserCertificates();
            }
        },
        fetchUserCertificates: function () {
            this.loading = true
            this.results = []
            this.restFetchParams(this.certificateUrl, {activeUsers: this.activeUsers ? 1 : 0}, this.handleCertificateResponse, this.fail)
        },
        handleCertificateResponse: function (response) {
            this.loading = false
            if (response.data) {
                this.results = response.data
            }
        },
        fail: function () {
            this.loading = false
        },
    },

}
</script>
